import { render, staticRenderFns } from "./xc-infomation-share-list.vue?vue&type=template&id=6f730972&scoped=true"
import script from "./xc-infomation-share-list.vue?vue&type=script&lang=js"
export * from "./xc-infomation-share-list.vue?vue&type=script&lang=js"
import style0 from "./xc-infomation-share-list.vue?vue&type=style&index=0&id=6f730972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f730972",
  null
  
)

export default component.exports